

















import {Component, Prop, Vue} from "vue-property-decorator";
import ThemesStore from "@/store/modules/ThemesStore";
import SettingOptionUI from "@/components/UI/SettingOptionUI.vue";
import ThemeCategoryVariablesStore from "@/store/modules/ThemeCategoryVariablesStore";
import {Util} from "@/_global/utils";

@Component({
    components: {
        SettingOptionUI
    },
})
export default class ThemeCategory extends Vue {
    @Prop() private settingOptions!: CMS.SettingOption[];
    @Prop() private categoryId!: number;


    // CMSで編集済みの値を返却
    private getEditedOptionValue(optionName: string): any {
        const categoryValue: CMS.ThemeCategoryVariable = ThemeCategoryVariablesStore.variableByCategoryId[this.categoryId];
        if ((!categoryValue) || (!categoryValue.value))
            return null;

        return categoryValue.value[optionName];
    }

    private onChange(option: string, value: string) {
        const themeCategoryVariable = ThemeCategoryVariablesStore.variableByCategoryId[this.categoryId];
        if (themeCategoryVariable) {
            let edited: CMS.ThemeCategoryVariable = Util.deepCopy(themeCategoryVariable);
            edited.value[option] = value;
            ThemeCategoryVariablesStore.localEdit(edited);
        } else {
            const newVariable: CMS.ThemeCategoryVariable = {
                theme_id: ThemesStore.selectedTheme.id,
                category_id: this.categoryId,
                value: {[option]: value}
            };
            ThemeCategoryVariablesStore.localAdd(newVariable);
        }
    }
}
